import { createPathFromPoints } from "../../../../helpers/svg";

type ChannelParabolaProps = {
  channel: { centralFrequencyHz: string, bandwidth: string },
  offsetY: number,
  containerWidth: number;
  canvasWidthInHz: number;
  startFrequency: number;
}

function square(a: number): number {
  return Math.pow(a, 2);
}

function createParabolaPath(offsetX: number, width: number, offsetY: number, height: number) {
  const data = new Array(201).fill(1).map((_, index) => {
    const currentValue = 1 - (index / 100);
    return {
      x: currentValue * (width / 2) + offsetX + width / 2,
      y: square(currentValue) * height + offsetY,
    }
  })

  return createPathFromPoints(data);
}

const ChannelParabola = ({
  channel,
  offsetY,
  canvasWidthInHz,
  startFrequency,
  containerWidth,
}: ChannelParabolaProps) => {
  const centralFrequencyHz = parseInt(channel.centralFrequencyHz);
  const bandwidth = parseInt(channel.bandwidth);
  const oneHzInPx = containerWidth / canvasWidthInHz;
  const path = createParabolaPath(
    ((centralFrequencyHz - (bandwidth / 2)) * oneHzInPx - startFrequency * oneHzInPx),
    bandwidth * oneHzInPx,
    offsetY + 10,
    150
  );

  return (
    <path
      d={path}
      stroke="#007DFF"
      fill="rgba(0, 125, 255, 0.5)"
    />
  );
}

export default ChannelParabola;